import { createAsyncAction } from "typesafe-actions";
import {FacilityExtraDto, FacilityInfoDto} from './visitorInformation.dtos'

export const facilityInfoActions = createAsyncAction(
    'GET_FACILITY_INFO_REQUEST',
    'GET_FACILITY_INFO_SUCCESS',
    'GET_FACILITY_INFO_ERROR',
  )<string, FacilityInfoDto, string>();
  
  export const facilityExtrasActions = createAsyncAction(
    'GET_FACILITY_EXTRAS_REQUEST',
    'GET_FACILITY_EXTRAS_SUCCESS',
    'GET_FACILITY_EXTRAS_ERROR',
  )<[], FacilityExtraDto[], string>();
  
  export const updateFacilityInfoActions = createAsyncAction(
    'UPDATE_FACILITY_INFO_REQUEST',
    'UPDATE_FACILITY_INFO_SUCCESS',
    'UPDATE_FACILITY_INFO_ERROR',
  )<FacilityInfoDto, FacilityInfoDto, string>();
  
  export const createFacilityInfoActions = createAsyncAction(
    'CREATE_FACILITY_INFO_REQUEST',
    'CREATE_FACILITY_INFO_SUCCESS',
    'CREATE_FACILITY_INFO_ERROR',
  )<FacilityInfoDto, FacilityInfoDto, string>();

  export const updateFacilityExtraActions = createAsyncAction(
    'UPDATE_FACILITY_EXTRA_REQUEST',
    'UPDATE_FACILITY_EXTRA_SUCCESS',
    'UPDATE_FACILITY_EXTRA_ERROR',
  )<FacilityExtraDto[], FacilityExtraDto[], string>();
  
  export const createFacilityExtraActions = createAsyncAction(
    'CREATE_FACILITY_EXTRA_REQUEST',
    'CREATE_FACILITY_EXTRA_SUCCESS',
    'CREATE_FACILITY_EXTRA_ERROR',
  )<FacilityExtraDto[], FacilityExtraDto[], string>();